import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import React from 'react';
import { searchBarComponent } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import PersonIcon from '@mui/icons-material/Person';


const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25)
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '340px',
    height: '17px'
  }
}));

export default function CustomerSearchAppBar(props) {
  const { data, searchData } = props;
  const [searchText, setSearchText] = React.useState('');
  const [search, setSearch] = React.useState(false);
  const [dropDown, setDropDown] = React.useState(false);
  const [dropDownData, setDropDownData] = React.useState('');
  const debounceRef = React.useRef(null);

const handleInputChange = (e) => {
  const value = e.target.value;
  setSearchText(value);

  if (debounceRef.current) {
    clearTimeout(debounceRef.current); // clear previous timer
  }

  // set a new debounce timer
  debounceRef.current = setTimeout(() => {
    const trimValue = value.trimStart();
    if (trimValue.length >= 3) {
      setDropDown(true);
      searchData(trimValue);
    } else {
      setDropDown(false);
    }
  }, 2000); // 2000ms delay
};


  const handleOptionClick = (id: number) => {
    props.handleCustomerSelect(id); 
    setSearchText(''); 
    setDropDown(false); 
  };

  return (
    <>
      <div
        style={{
          ...searchBarComponent.container,
          position: 'relative',
          alignItems: dropDown ? 'flex-start' : 'center'
        }}
      >
        <div>
          <div
            style={
              !dropDown
                ? searchBarComponent.searchBarContainer.container
                : searchBarComponent.searchBarContainer.dropDown
            }
          >
            <div style={searchBarComponent.searchBarContainer.container}>
              <SearchIcon style={searchBarComponent.searchBarContainer.icon} />
              <input
                type="text"
                value={searchText}
                onChange={handleInputChange}
                placeholder="Search customer by name or mobile"
                style={searchBarComponent.searchBarContainer.inputFeild}
              />
            </div>
            {dropDown && (
              <div
                style={{
                  ...searchBarComponent.searchBarContainer.renderBox,
                  display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto',
                  width: '36vw',
                  minWidth: '100px',
                }}
              >
                {props.searchResults?.length > 0 ? (
                  props.searchResults.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => handleOptionClick(item.id)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '5px 10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #ddd',
                        backgroundColor: '#fff', // optional: keep white background
                      }}
                    >
                      <PersonIcon
                        style={{
                          marginRight: '10px',
                          color: '#666',
                          minWidth: '24px',
                        }}
                      />
                      <div>
                        {item.firstAndMiddleName} {item.lastName} - {item.mobileNumber}
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: '5px 10px', color: 'gray' }}>No customers found</div>
                )}
              </div>
            )}



          </div>
        </div>
        <Button
          style={{
            paddingTop: '10px',
            borderRadius: '5px',
            marginLeft: '10px',
            cursor: 'pointer',
            backgroundColor: 'blue',
            color: 'white',
            border: 'none',
            outline: 'none'
          }}
          variant="contained"
          onClick={() => props.addPageClick('addPage')}
        >
          {props.buttonText}
        </Button>
      </div>
    </>
  );
}
